// extracted by mini-css-extract-plugin
export var editButton = "_ij-0";